import styles from './staffResourceHeader.module.scss'

type StaffResourceHeaderProps = {
  name: string
}

export const StaffResourceHeader = ({ name }: StaffResourceHeaderProps) => {
  return <div className={styles.header}>{name}</div>
}
